var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "150px",
    height: "150px",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 150,
    height: 150,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1,
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 41.746094 0.179688 C 18.789062 0.179688 0.179688 18.789062 0.179688 41.746094 L 0.179688 108.253906 C 0.179688 131.207031 18.789062 149.820312 41.746094 149.820312 L 108.253906 149.820312 C 131.207031 149.820312 149.820312 131.207031 149.820312 108.253906 L 149.820312 41.746094 C 149.820312 18.789062 131.207031 0.179688 108.253906 0.179688 Z M 124.878906 16.808594 C 129.449219 16.808594 133.191406 20.546875 133.191406 25.121094 C 133.191406 29.691406 129.449219 33.433594 124.878906 33.433594 C 120.304688 33.433594 116.566406 29.691406 116.566406 25.121094 C 116.566406 20.546875 120.304688 16.808594 124.878906 16.808594 Z M 75 33.433594 C 97.957031 33.433594 116.566406 52.042969 116.566406 75 C 116.566406 97.957031 97.957031 116.566406 75 116.566406 C 52.042969 116.566406 33.433594 97.957031 33.433594 75 C 33.433594 52.042969 52.042969 33.433594 75 33.433594 Z M 75 50.058594 C 61.222656 50.066406 50.054688 61.238281 50.058594 75.015625 C 50.066406 88.792969 61.238281 99.960938 75.015625 99.957031 C 88.792969 99.953125 99.960938 88.777344 99.957031 75 C 99.953125 61.222656 88.777344 50.054688 75 50.058594 Z M 75 50.058594 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.f5c52fcf59b88243ec705f7c9d8b229d.svg";
export { ForwardRef as ReactComponent };